import React from 'react';
import { Typography } from 'lib/components';
import { Message } from 'types';
import classes from '../index.module.scss';
import moment from 'moment';

/**
 * Props for the ChatMessage component
 */
interface Props {
	chat: Message; // The message data to display
	isSender: boolean; // Whether the current user is the sender of this message
}

/**
 * Component for displaying a single chat message
 * Renders differently based on whether the current user is the sender or receiver
 *
 * @param chat - The message data to display
 * @param isSender - Whether the current user is the sender of this message
 */
const ChatMessage = ({ chat, isSender }: Props) => (
	<div
		className={`${classes['chatPopup-chatMessage']} ${
			// Apply different styling based on whether the user is the sender or receiver
			isSender ? classes['chatPopup-chatMessage-sender'] : classes['chatPopup-chatMessage-receiver']
		}`}
	>
		{/* Message content */}
		<div>
			<Typography>{chat.message}</Typography>
		</div>
		{/* Message timestamp - converted from UTC to local time */}
		<Typography className={classes['chatPopup-chatPeriod-label']}>
			{moment.utc(chat.createdAt, 'MM/DD/YYYY hh:mm A').local().format('MM/DD/YYYY hh:mm A')}
		</Typography>
	</div>
);

export default ChatMessage;
